import { COUNTRIES } from './countries';

export type PhoneParts = { prefix: string; number: string };

const SORTED = [...COUNTRIES].sort(
  (a, b) => b.dialCode.length - a.dialCode.length
);

export function splitPhone(stored: string): PhoneParts {
  if (!stored) return { prefix: '', number: '' };
  for (const c of SORTED) {
    if (stored.startsWith(c.dialCode)) {
      return { prefix: c.dialCode, number: stored.slice(c.dialCode.length) };
    }
  }
  return { prefix: '', number: stored };
}

export function joinPhone(parts: PhoneParts): string {
  const num = parts.number.replace(/\s/g, '');
  if (!num && !parts.prefix) return '';
  return `${parts.prefix}${num}`;
}
